import Error from '../../../components/Error/Error';
import HeaderTitle from '../../../components/Title/HeaderTitle';
import Loading from '../../../components/Loading/Loading';
import React, { FC, useEffect } from 'react';
import { Drawer } from '../../../components/Modal/Drawer';
import { LibraryHeaderBackground } from '../../../components/Library/LibraryHeaderBackground';
import { LibraryWithAnyData } from '../../../components/Library/LibraryWithAnyData';
import { SPACING } from '../../../config/designSystem/Spacing';
import { Toggle, ToggleProps } from '../../../components/Toggle/Toggle';
import { View } from 'react-native';
import { marginHorizontalLibrary } from '../../../constants/layout';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useIsConnected } from '../../../hooks/useIsConnected';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useScrollToTop } from 'expo-router';
import { useStores } from '../../../hooks/useStores';





const Library: FC = observer(() => {
  const rootStore = useStores();

  const connected = useIsConnected();
  const dataPaths = rootStore?.categories.getCategoriesFormatedForPath();
  const dataActivities = rootStore?.categories.getCategoriesFormatedForActivities();
  const labels = rootStore?.language.translate.MOBILE?.LIBRARY;
  const tabSelected  = rootStore?.user?.tabSelected;

  const pathIsSelected = tabSelected !== 'activities';

  const data = pathIsSelected ? dataPaths : dataActivities;
  const visitedPage = pathIsSelected?'LIBRARY_PATH':'LIBRARY_ACTIVITY';


  const alreadyVisitedPath = rootStore?.onboarding?.isVisited('LIBRARY_PATH');
  const alreadyVisitedActivity = rootStore?.onboarding?.isVisited('LIBRARY_ACTIVITY');
  const alreadyVisited = pathIsSelected ? alreadyVisitedPath : alreadyVisitedActivity;


  const [modalVisible,setModalVisible] = React.useState(!alreadyVisited);

  const ref = React.useRef(null);
  useScrollToTop(ref);

  useEffect(() => {
    const visited = pathIsSelected ? alreadyVisitedPath : alreadyVisitedActivity;
    setModalVisible(!visited);
  }, [alreadyVisitedPath,alreadyVisitedActivity,pathIsSelected]);







  const insets = useSafeAreaInsets();

  const { width } = useAvailableDimensions();
  const HEIGHT_TOP = Math.min(width/390*286,300);







  const renderHeader = () => {
    return (
      <>
        <View style={{ width}}>
          <View style={{position: 'absolute'}}>
            <LibraryHeaderBackground width={width} height={HEIGHT_TOP}/>
          </View>
          <View style={{ marginTop: (insets.top || 48) + SPACING['sp-16'], marginBottom: SPACING['sp-16'] , marginHorizontal: marginHorizontalLibrary,  rowGap: SPACING['sp-24']}}>
            <HeaderTitle title={labels?.TITLE || 'How can we help you today?'}/>

            {renderTabs()}
          </View>
        </View>
      </>);
  };

  const renderTabs = () => {
    const tabs: ToggleProps = {
      indexSelected: 0,
      tabs: [
        {
          label: labels?.PATHS || 'Paths',
          onPress: () => {rootStore?.user?.setTabSelected('paths');
          }
        },
        {
          label: labels?.ACTIVITIES || 'Activities',
          onPress: () => {
            rootStore?.user?.setTabSelected('activities');
          }
        },
      ],
    };
    return (
      <View>
        <Toggle {...tabs} indexSelected={tabSelected === 'activities'? 1 : 0}/>
      </View>);

  };




  const renderDrawer = () => {
    const title = pathIsSelected? labels?.WHAT_IS_A_PATH_TITLE: labels?.WHAT_IS_AN_ACTIVITY_TITLE;
    const text = pathIsSelected? labels?.WHAT_IS_A_PATH_TEXT: labels?.WHAT_IS_AN_ACTIVITY_TEXT;
    const button = pathIsSelected? labels?.WHAT_IS_A_PATH_BUTTON: labels?.WHAT_IS_AN_ACTIVITY_BUTTON;
    const onDismiss = () => {
      rootStore?.onboarding?.setVisitedPages(visitedPage);
      setModalVisible(false);

    };
    return (<Drawer
      mainText={text}
      buttonMainActionText={button}
      titleText={title}
      onDismiss={onDismiss}
      onMainAction={onDismiss}
      isVisible={modalVisible}
    />

    );

  };



  if(rootStore?.categories.state === 'error') {
    return <Error network={!connected} labels={rootStore?.language.translate.MOBILE?.ERROR} />;
  }

  if ( !data || !(data.length > 0)) {
    return (
      <Loading
        withLabel={false}
      />
    );
  }



  return (
    <>
      {renderDrawer()}
      <LibraryWithAnyData data={data} header={renderHeader}  showAll={!pathIsSelected}/>
    </>
  );
});

export default Library;
